class RecentlyViewed {
  constructor() {
    this.product = window.recentlyViewed.current.product;

    this.tags = {
      diy: window.recentlyViewed.brandTags.diy?.map((tag) => `boschType:${tag}`) || [],
      pro: window.recentlyViewed.brandTags.pro?.map((tag) => `boschType:${tag}`) || [],
    };

    this.recentlyViewedProducts = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];
    this.recentlyViewedProProducts = this.recentlyViewedProducts.pro || [];
    this.recentlyViewedDiyProducts = this.recentlyViewedProducts.diy || [];

    // Return if there is no product
    if (!this.product) return;

    this.setItem();
  }

  setItem() {
    let value = {
      pro: this.recentlyViewedProProducts,
      diy: this.recentlyViewedDiyProducts,
    };
    const { tags, url } = this.product;

    tags.forEach((productTag) => {
      switch (true) {
      case this.tags.pro.includes(productTag):
        // Check if the product is already in the list
        if (this.recentlyViewedProProducts.includes(url)) break;

        // Add the product to the list
        value.pro.push(url);
        break;

      case this.tags.diy.includes(productTag):
        // Check if the product is already in the list
        if (this.recentlyViewedDiyProducts.includes(url)) break;

        // Add the product to the list
        value.diy.push(url);
        break;
      }
    });

    localStorage.setItem('recentlyViewedProducts', JSON.stringify(value));
  }
}

new RecentlyViewed();
